/**
 * /frontend/src/features/analytics/components/offers/OfferPerformanceComparisonChart.js
 */

import React, { useMemo } from 'react';
import ChartContainer from '../shared/ChartContainer';
import GroupedBarChart from '../charts/GroupedBarChart';
import { CHART_COLORS } from '../../constants/chartColors';

/**
 * Per-offer views, claims, and redemptions comparison.
 * @param {{data:Array<{label:string,views:number,claims:number,redemptions:number}>}} props
 * @returns {JSX.Element}
 */
const OfferPerformanceComparisonChart = ({ data }) => {
  const bars = useMemo(() => ([
    { key: 'views', label: 'Views', color: CHART_COLORS.accentCyan },
    { key: 'claims', label: 'Claims', color: CHART_COLORS.warning },
    { key: 'redemptions', label: 'Redemptions', color: CHART_COLORS.success }
  ]), []);

  return (
    <ChartContainer
      title="Offer Performance"
      subtitle="Views, claims, and redemptions by offer"
      exportFilename="offer-performance-comparison"
      exportRows={data}
    >
      <GroupedBarChart
        data={data}
        xKey="label"
        bars={bars}
        height={340}
        yFormatter={(value) => Number(value || 0).toLocaleString('en-IN')}
      />
    </ChartContainer>
  );
};

export default OfferPerformanceComparisonChart;
